import React from 'react';
import PropTypes from 'prop-types';
import {navigateOnClick} from "utils/navigateOnClick";
import {TableCell, TableRow} from "@mui/material";
import {useHistory} from "react-router-dom";
import {OMSRoutes} from "utils/OMSRoutes";
import {grey25, greyishBlue100} from "assets/jss/main";
import {sessionStore} from "utils/sessionStore";
import {Authorizations, hasAuthorization} from "utils/authorizations";
import OrderInfos from "./components/OrderInfos";
import RetailerBadgeList from "./components/RetailerBadgeList";
import CustomerInfos from "./components/CustomerInfos";
import ZoneAndType from "./components/ZoneAndType";
import Total from "./components/Total";
import LineItemStatusesBadgeList from "./components/LineItemStatusesBadgeList";
import TrackingNumbers from "./components/TrackingNumbers";
import Runner from "./components/Runner";
import OrderNotes from "./components/OrderNotes";

OrderRow.propTypes = {
    order: PropTypes.object.isRequired
};

function OrderRow({order, ...props}) {
    const history = useHistory();

    const {
        id,
        externalId,
        createdAt,
        lineItems,
        customerShippingFirstname,
        customerShippingLastname,
        placedAsGuest,
        customerOrdersCount,
        shipments,
        total,
        retailerTotal,
        adjustments,
        customerCommentCount,
        internalNoteCount,
        returns
    } = order;

    return (
        <TableRow
            hover
            sx={{
                cursor: 'pointer',
                border: `1px solid ${greyishBlue100}`,
                "td" : {padding: '16px 10px'},
                "td:last-of-type": { paddingRight: '16px', borderRight: `1px solid ${greyishBlue100}` },
                "td:first-of-type": { paddingLeft: '16px', borderLeft: `1px solid ${greyishBlue100}` },
                "&.MuiTableRow-hover:hover": { backgroundColor: grey25 },
            }}
            onClick={(e) => navigateOnClick(e, OMSRoutes.ORDER(id), history)}
        >
            <TableCell sx={{ py: "16px", pl: "16px", verticalAlign: "top" }}>
                <OrderInfos externalId={externalId} date={createdAt} lineItems={lineItems} />
                <div style={{marginTop: '8px'}}>
                    <RetailerBadgeList orderId={id} lineItems={lineItems} />
                </div>
            </TableCell>
            <TableCell sx={{ py: "16px", pl: "16px", verticalAlign: "top" }}>
                <CustomerInfos
                    firstName={customerShippingFirstname}
                    lastName={customerShippingLastname}
                    isGuest={placedAsGuest}
                    totalOrderCount={customerOrdersCount}
                />
            </TableCell>
            <TableCell sx={{ py: "16px", pl: "16px", verticalAlign: "top" }}>
                <ZoneAndType shipments={shipments} />
            </TableCell>
            <TableCell sx={{ py: "16px", pl: "16px", verticalAlign: "top",  minWidth: '168px' }}>
                <Total total={total} retailerTotal={retailerTotal} adjustments={adjustments} lineItems={lineItems} />
            </TableCell>
            <TableCell sx={{ py: "16px", pl: "16px", verticalAlign: "top" }}>
                <LineItemStatusesBadgeList lineItems={lineItems} />
            </TableCell>
            <TableCell sx={{ py: "16px", pl: "16px", verticalAlign: "top" }}>
                <TrackingNumbers orderId={id} shipments={shipments} returns={returns} />
            </TableCell>
            {!hasAuthorization(sessionStore.get('authorizations'), Authorizations.PICKING_RETAILER) && (
                <TableCell sx={{ py: "16px", pl: "16px", verticalAlign: "top", maxWidth:'140px' }}>
                    <Runner orderId={id} lineItems={lineItems} />
                </TableCell>
            )}
            <TableCell sx={{ py: "16px", pl: "16px", verticalAlign: "top" }}>
                <OrderNotes customerCommentCount={customerCommentCount} internalNoteCount={internalNoteCount} />
            </TableCell>
        </TableRow>
    );
}

export default OrderRow;
